<ng-container *ngIf="faqCategories">
  <account-faqs-page-nav
    class="faq-nav"
    [categories]="faqCategoryTitles"
    [activeIndex]="activeCategoryIndex"
    (selectCategory)="onSelectCategory($event)"
  ></account-faqs-page-nav>
  <div class="faqs-content">
    <ng-container *ngIf="activeCategory.dynamicDescriptions?.length">
      <div
        *ngFor="let description of activeCategory.dynamicDescriptions"
        [innerHTML]="description.content | safeHtml"
        class="faq-description ods-typography-body-s-regular"
      ></div>
    </ng-container>
    <div class="faqs-container">
      <faqs class="promo-page-faqs" [faqQuestions]="activeCategory.questions"></faqs>
    </div>
  </div>
</ng-container>
